var React = require('react');

function AsanaDog (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M8,31H1c0,0,1.438-7.464,5.57-18.438\n\tC8.45,7.57,10.625,7,13.248,7c3,0,4.562,2.313,7.752,7c2.517,3.697,11,17,14,17c1,0,3,0,3,0 M29.65,26.268\n\tc0,0-0.275,2.732-3.9,2.732C22.438,29,21,25.232,21,23.954c0-1.442,0.357-2.377,0.625-2.954c-1,0-3.25,0.001-4.938-1.491\n\ts-2.903-4.287-4.313-5.696c0,0-4.676,6.355-8,17.188"}));
}

AsanaDog.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaDog;

AsanaDog.default = AsanaDog;
